@use '~/theme/theme' as *;
@use '~/theme/typography';

.account {
  min-width: 350px;
}

.tooltipControl {
  outline: none;
  width: 100%;
}

.documentSelection {
  padding: 0 spacing(1);
  min-width: 200px;
}

.selectedDocument {
  flex: 1;
}

.tooltip {
  padding: spacing(0.5);
  max-width: 416px;

  .recommendedReconciliation {
    .text {
      color: color(grey-700);
    }

    .icon {
      @include border-radius(xl);

      width: 24px;
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: color(orange-300);
    }
  }

  .trendUpIcon {
    color: color(green-800);
  }

  .trendDownIcon {
    color: color(lobster-800);
  }
}

.counterpartColumn {
  min-width: 200px;
}

.adjustmentCell {
  text-align: center;
}
